import { IDataSourcePathCommand, IFile, IS3File, WorkflowMessage } from 'interfaces-lib';
import { WorkflowTask } from 'workflow-task-service-lib';
import { IBullhornCardContext } from '../types/bullhorn-card-context';
import { IMessageHandlerComponent } from '../types/component-method-message-handler';
import { INTRequest } from '../types/NTRequest';

export class NotetakerResponseTask extends WorkflowTask {
  private readonly startParams: any;
  constructor(
    private noteTakerRequest: INTRequest,
    private bullhornCardContext: IBullhornCardContext,
    private component: IMessageHandlerComponent
  ) {
    super('TRANSCRIBE_AND_ANSWER');
    this.startParams = this.buildStartParams(this.noteTakerRequest);
  }

  override getStartParams(): any {
    return this.startParams;
  }

  override receive(message: WorkflowMessage): boolean {
    if (message.type === MESSAGE_TYPE.ERROR_EVENT) {
      this.component.handleError(message);
      return true;
    }

    if (message.type === MESSAGE_TYPE.AI_SERVICE_STATUS) {
      this.component.handleMessage(message);
      return false;
    }

    if (message.type === MESSAGE_TYPE.AI_TRANSCRIBE_RESPONSE) {
      this.component.handleMessage(message);
      return false;
    }

    if (message.type === MESSAGE_TYPE.AI_QUESTION_RESPONSE) {
      this.component.handleMessage(message);
      return true;
    }

    console.debug(`Message '${message.type}' not handled.`);

    return false;
  }

  private buildStartParams(noteTakerRequest: INTRequest): any {
    const startParams = {
      source: this.getSourceFile(noteTakerRequest),
      questions: noteTakerRequest.questionPackId,
      entityData: noteTakerRequest.entity,
      transcribe: noteTakerRequest.transcribe,
      aiModel: {
        transcribe: noteTakerRequest.transcribeModel,
        question: noteTakerRequest.questionModel,
      },
      callId: noteTakerRequest.callId,
    };

    console.log('merge startParams', startParams);
    return startParams;
  }

  private getSourceFile(noteTakerRequest: any): IDataSourcePathCommand {
    if (noteTakerRequest.file?.s3) {
      return this.mapS3FileToSource(noteTakerRequest.file);
    } else if (noteTakerRequest?.file?.namespace) {
      return noteTakerRequest.file;
    }
    return this.mapEntityFileToSource('bullhorn', noteTakerRequest.file);
  }

  private mapS3FileToSource(file: IS3File): any {
    return {
      namespace: 'S3',
      path: file.s3.path,
    };
  }

  private mapEntityFileToSource(namespace: string, file: IFile): IDataSourcePathCommand {
    return {
      namespace: namespace,
      path: [
        this.bullhornCardContext.cardEntityType,
        this.bullhornCardContext.cardEntityId.toString(),
        file.id,
      ],
    };
  }
}

export enum MESSAGE_TYPE {
  ERROR_EVENT = 'ErrorEvent',
  AI_SERVICE_STATUS = 'AiServiceStatus',
  AI_TRANSCRIBE_RESPONSE = 'AiTranscribeResponse',
  AI_QUESTION_RESPONSE = 'AiQuestionResponse',
}
